// Firebase wiring — vocab-kit production config. The apiKey/appId/senderId are
// PUBLIC client identifiers (distributed in every shipped bundle; real access
// control is Firestore rules + Auth, per Firebase's own model). Env vars stay
// the override path for dev/emulator: VITE_FIREBASE_* or VITE_FIREBASE_EMULATOR=1.
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { initAnalytics } from "./analytics";

const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID || "vocab-kit";

const app = initializeApp({
  projectId,
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:730559957556:web:d8de871e222a46baef1861",
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyBvMjPNYWzfKUuhDBpDhuOMFlYMVWXO3dk",
  authDomain: `${projectId}.firebaseapp.com`,
  storageBucket: `${projectId}.firebasestorage.app`,
  messagingSenderId: import.meta.env.VITE_FIREBASE_SENDER_ID || "730559957556",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || undefined,
});

initAnalytics(app);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "us-central1");

if (import.meta.env.DEV && import.meta.env.VITE_FIREBASE_EMULATOR === "1") {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectStorageEmulator(storage, "127.0.0.1", 9199);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}
